import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, Router, RouterProvider ,Outlet,createBrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import "./index.css";
import { KeycloakConfig } from "keycloak-js";
import { KeycloakAuth } from './components/Login/keycloakUserService';
import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import { createRoot } from "react-dom/client";



const keycloakConfig: KeycloakConfig = {
        url: 'https://xadmin.lexxtechnologies.com/auth/',
    realm: 'xAssist 2.0',
    clientId: 'x-team'
  };

initializeIcons();
const router = createBrowserRouter([
    { 
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Chat />
            },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);
    const root = createRoot(document.getElementById("root") as Element);
root.render(
    
    <KeycloakAuth config={keycloakConfig}>
            <RouterProvider router={router} />
            </KeycloakAuth>
    );